document.addEventListener('DOMContentLoaded', function() {
    let modal = document.querySelector('#modal-pro-registration');
    let closeButton = document.querySelector('#modal-pro-registration .close');
    let sendButton = document.querySelector('#modal-pro-registration p.aveine-button');

    function closeModal() {
        modal.style.display = 'none';
    }

    function sendInvitation() {
        let email = document.querySelector('#modal-pro-registration input').value;
        $.ajax({
            type: 'POST',
            url: `https://pro.api.aveine.paris/pro/invitations/ambassador?lang=${Shopify.locale}`,
            data: JSON.stringify({
                data: {
                    type: 'invitations',
                    attributes: {
                        email
                    }
                }
            }),
        }).always(() => {
            closeModal();
        });
    }

    closeButton.addEventListener('click', closeModal);
    sendButton.addEventListener('click', sendInvitation)

    /* let registrationButtons = document.querySelectorAll("a[href='https://app.aveine.paris']");

    registrationButtons.forEach((button) => {
        button.addEventListener('click', (event) => {
            modal.style.display = 'flex';
            event.preventDefault();
        })
    }) */
});